import type { HousekeepingRoomStatus } from '../../pages/housekeeping/types/housekeeping';

/**
 * Les deux listes de « Contrôles » : le ménage terminé qui attend la gouvernante,
 * puis les chambres propres qu'elle peut recontrôler (une chambre peut servir la
 * nuit sans être louée). Tri par nom, comme on fait sa tournée.
 */
export interface ChambresAControler {
    aControler: HousekeepingRoomStatus[];
    propres: HousekeepingRoomStatus[];
}

const parNom = (a: HousekeepingRoomStatus, b: HousekeepingRoomStatus) =>
    (a.room_name ?? '').localeCompare(b.room_name ?? '', 'fr', { numeric: true });

export function repartirControles(chambres: HousekeepingRoomStatus[]): ChambresAControler {
    return {
        aControler: chambres.filter((c) => c.status === 'to_inspect').sort(parNom),
        propres: chambres.filter((c) => c.status === 'free_clean' && !c.is_common_area).sort(parNom),
    };
}
